export function setHrefTargetBlank(content: string) {
    return ("" + content).replace(/<a\s+href=/gi, '<a target="_blank" href=');
}
